import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useCreateSalaryTypes } from 'src/hooks/salary-types/create-salary-types.hook';
import { useUpdateSalaryTypes } from 'src/hooks/salary-types/update-salary-types.hook';
import { useGetSalaryTypesById } from 'src/hooks/salary-types/get-salary-types-by-id.hook';
import { useGetLocationsAssignedDatevNumbers } from 'src/hooks/companies/get-locations-datevnumbers.hook';


import { SalaryTypesForm } from './components/salary-types-form';
import { ISalaryTypesTableValues } from './salary-types-interfaces';

const ChangeSalaryTypes = ({ id, onClose }: { id?: string; onClose: () => void }) => {
  const { salaryType, loading } = useGetSalaryTypesById(id);
  const { createSalaryTypes, loading: createLoading } = useCreateSalaryTypes({
    onSuccess: onClose,
  });
  const { updateSalaryTypes, loading: updateLoading } = useUpdateSalaryTypes({
    onSuccess: onClose,
  });

  const currentCompanyId = useGetCurrentCompanyId();

  const { _id, name, salaryTypeNumber, clientNumbers } = salaryType || {};

  const handler = _id ? updateSalaryTypes : createSalaryTypes;
  const loader = _id ? updateLoading : createLoading;

  const isEdit = salaryType?._id;

  const { datevNumbers } = useGetLocationsAssignedDatevNumbers();

  const initialValue = isEdit
    ? {
        name,
        salaryTypeNumber,
        clientNumbers,
      }
    : ({} as ISalaryTypesTableValues);

  const onFinish = (values: ISalaryTypesTableValues) => {
    handler({
      variables: {
        payload: {
          ...(_id && { _id }),
          ...values,
          companyId: currentCompanyId,
        },
      },
    });
  };

  if (loading) return <Loader />;

  return (
    <SalaryTypesForm
      isEdit={isEdit}
      initialValues={initialValue}
      onClose={onClose}
      loading={loader}
      onFinishHandler={onFinish}
      datevNumbers={datevNumbers}
    />
  );
};

export default ChangeSalaryTypes;
